// Module
var code = "<div id=unsubscribe-newsletter><h1>You've been unsubscribed from all our newsletters!</h1></div>";
// Exports
module.exports = code;